import { useContext } from "react";
import { Button, Input, Modal, Table, Tag, Typography } from "antd";
import {
    GiftOutlined,
    PlusOutlined,
    SearchOutlined,
} from "@ant-design/icons";

import useAwardTypes from "./useAwardTypes";
import PageHeader from "../../components/PageHeader";
import ActiveFiltersBar from "../../components/ActiveFiltersBar";
import TableCard from "../../components/TableCard";
import TableDicaHint from "../../components/TableDicaHint";
import TablePagination from "../../components/TablePagination";
import { ThemeContext } from "../../contexts/ThemeContext";
import { poeValorComPontosEmMil } from "../../utils/Conversores";

const { Paragraph } = Typography;

export default function AwardTypes() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const {
        isLoading,
        isDeleteModalVisible,
        isLoadingDelete,
        awardTypeBeingDeleted,
        columns,
        tableData,
        filteredData,
        searchText,
        setSearchText,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        activeFilterItems,
        handleClickCreateNewAwardType,
        handleClickEditAwardType,
        handleConfirmDeleteAwardType,
        handleCancelDeleteAwardType,
        handleClearAllFilters,
    } = useAwardTypes();

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <PageHeader
                icon={<GiftOutlined />}
                iconBg="linear-gradient(135deg, #faad14 0%, #d48806 100%)"
                title="Tipos de Prêmios"
                tag={<Tag color="gold">{poeValorComPontosEmMil(tableData.length)} cadastrados</Tag>}
                subtitle="Gerencie as categorias e tipos de prêmios padrão cadastrados para sorteios"
                actions={
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleClickCreateNewAwardType}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            fontWeight: 600,
                            height: 38,
                            borderRadius: 8,
                        }}
                    >
                        Novo Tipo de Prêmio
                    </Button>
                }
            />
            <div
                style={{
                    background: isDark ? "#141414" : "#ffffff",
                    border: `1px solid ${isDark ? "#262626" : "#e2e8f0"}`,
                    borderRadius: 10,
                    padding: "12px 16px",
                    display: "flex",
                    alignItems: "flex-end",
                    flexWrap: "wrap",
                    gap: 14,
                }}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: 4, flex: 1, minWidth: 240, maxWidth: 380 }}>
                    <span style={{ fontSize: 12, fontWeight: 600, color: isDark ? "#d4d4d4" : "#475569" }}>
                        Pesquisar Tipo de Prêmio
                    </span>
                    <Input
                        placeholder="Buscar por nome do tipo de prêmio..."
                        prefix={<SearchOutlined style={{ color: "#94a3b8" }} />}
                        value={searchText}
                        onChange={(e) => {
                            setSearchText(e.target.value);
                            setCurrentPage(1);
                        }}
                        allowClear
                        style={{ borderRadius: 8, height: 36 }}
                    />
                </div>
            </div>

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Clique em uma linha para editar o tipo de prêmio ou utilize os botões de ação à direita." />

            <TablePagination
                current={currentPage}
                pageSize={pageSize}
                total={filteredData.length}
                itemName="tipos de prêmios"
                pageSizeOptions={["10", "25", "50", "100"]}
                onChange={(page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                }}
            />
            <TableCard>
                <Table
                    columns={columns as any}
                    dataSource={filteredData.slice(
                        (currentPage - 1) * pageSize,
                        currentPage * pageSize
                    )}
                    rowKey="key"
                    loading={isLoading}
                    pagination={false}
                    className={`modern-data-table ${isDark ? "modern-data-table-dark" : ""}`}
                    scroll={{ x: 650 }}
                    onRow={(record) => ({
                        onClick: () => handleClickEditAwardType(record),
                        style: { cursor: "pointer" },
                    })}
                />
            </TableCard>

            <TablePagination
                current={currentPage}
                pageSize={pageSize}
                total={filteredData.length}
                itemName="tipos de prêmios"
                pageSizeOptions={["10", "25", "50", "100"]}
                onChange={(page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                }}
            />

            <Modal
                open={isDeleteModalVisible}
                onOk={handleConfirmDeleteAwardType}
                onCancel={handleCancelDeleteAwardType}
                confirmLoading={isLoadingDelete}
                okText="Sim, Deletar"
                cancelText="Cancelar"
                okType="danger"
                okButtonProps={{ loading: isLoadingDelete }}
                cancelButtonProps={{ disabled: isLoadingDelete }}
                centered
                title="Confirmar Exclusão de Tipo de Prêmio"
            >
                <Paragraph style={{ marginTop: 12 }}>
                    Deseja realmente deletar o tipo de prêmio{" "}
                    <strong>"{awardTypeBeingDeleted?.name}"</strong>?
                </Paragraph>
                <div
                    style={{
                        background: isDark ? "#1f1315" : "#fff1f0",
                        border: `1px solid ${isDark ? "#431418" : "#ffa39e"}`,
                        borderRadius: 6,
                        padding: "10px 14px",
                        fontSize: 12.5,
                        color: isDark ? "#ffa39e" : "#cf1322",
                    }}
                >
                    Esta ação removerá este tipo de prêmio. Prêmios vinculados a sorteios anteriores não serão afetados.
                </div>
            </Modal>
        </div>
    );
}
